import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { API_ENDPOINT } from '../../utils/Constants';

import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import dayjs, { Dayjs } from 'dayjs';

import Plotly from 'plotly.js';
import createPlotlyComponent from 'react-plotly.js/factory';
const Plot = createPlotlyComponent(Plotly);

const Graph2 = () => {
  const [startDate, setStartDate] = React.useState<Dayjs | null>(dayjs());
  const [endDate, setEndDate] = React.useState<Dayjs | null>(dayjs());

  const [task, setTask] = useState([]);
  const [taskset, setTaskset] = useState([]);
  const [operator, setOperator] = useState([]);
  const [selectedTaskset, setSelectedTaskset] = React.useState('');
  const [selectedTask, setSelectedTask] = React.useState('');
  const [selectedOperator, setSelectedOperator] = React.useState('');

  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [rowsTitle, setRowTitle] = useState([]);

  const layout: any = {
    title: 'ジョブ経過時間',
    titlefont: { size: 20, },
    hovermode: 'x unified',
    autosize: true,
    legend: { orientation: 'h', x: 0.5, y: -0.2, xanchor: 'center' },
    margin: { l: 120, b: 0, r: 30, t: 100, pad: 1 },
    xaxis: {
      title: '',
      titlefont: { size: 15 },
      tickfont: { size: 15 },
      showgrid: true,
      zerolinecolor: '#969696',
      zerolinewidth: 1,
      rangeslider: {borderwidth: 1,thickness: 0.25},
    },
    yaxis: {
      title: '',
      titlefont: { size: 15 },
      tickfont: { size: 15 },
      showgrid: true,
      zerolinecolor: '#969696',
      zerolinewidth: 1,
    }
  };

  const handleChange1 = (event: SelectChangeEvent) => {
    setSelectedTaskset(event.target.value as string);
  };

  const handleChange2 = (event: SelectChangeEvent) => {
    setSelectedTask(event.target.value as string);
  };

  const handleChange3 = (event: SelectChangeEvent) => {
    setSelectedOperator(event.target.value as string);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      axios
        .post(API_ENDPOINT + 'graph2', {
          startDate,
          endDate,
          selectedTaskset,
          selectedTask,
          selectedOperator,
        })
        .then((res) => {
          setData(res.data.data);
          const data = res.data.data;

          // table data
          const rw = [];
          const jobNameList = [];
          for (let i= 0; i < data.length; i++){
            if (jobNameList.indexOf(data[i][0]) === -1){
              jobNameList.push(data[i][0]);
            }
          }
          for (let k= 0; k < jobNameList.length; k++){
            rw.push({'jobName': jobNameList[k], 'data': []});
            for (let i= 0; i < data.length; i++){
              if (rw[k].jobName === data[i][0]){
                rw[k].data.push(data[i]);
              }
            }
          }
          setRows(rw);
          setRowTitle([{'tasksetName': selectedTaskset.split(':')[1], 'taskName': selectedTask.split(':')[1], 'operatorName': selectedOperator.split(':')[1]}]);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // -----------------
  const defaultTraces = useCallback((defaulTaskset, defaulTask, defaultOperator, ) => {
    axios.post(API_ENDPOINT + 'graph2', {
      'startDate': dayjs().subtract(1, 'h'),
      'endDate': dayjs(),
      'selectedTaskset': defaulTaskset,
      'selectedTask': defaulTask,
      'selectedOperator': defaultOperator
    })
      .then((res) => {
        setData(res.data.data);
        const data = res.data.data;

        // table data
        const rw = [];
        const jobNameList = [];
        for (let i= 0; i < data.length; i++){
          if (jobNameList.indexOf(data[i][0]) === -1){
            jobNameList.push(data[i][0]);
          }
        }
        for (let k= 0; k < jobNameList.length; k++){
          rw.push({'jobName': jobNameList[k], 'data': []});
          for (let i= 0; i < data.length; i++){
            if (rw[k].jobName === data[i][0]){
              rw[k].data.push(data[i]);
            }
          }
        }
        setRows(rw);
        setRowTitle([{'tasksetName': defaulTaskset.split(':')[1], 'taskName': defaulTask.split(':')[1], 'operatorName': defaultOperator.split(':')[1]}]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const getStatus = useCallback(() => {
    axios
      .get(API_ENDPOINT + 'graph2')
      .then((res) => {
        setTaskset(res.data.data[0]);
        setTask(res.data.data[1]);
        setOperator(res.data.data[2]);
        defaultTraces(
          res.data.data[0][0][0] + ':' + res.data.data[0][0][1],
          res.data.data[1][0][0] + ':' + res.data.data[1][0][1],
          res.data.data[2][0][0] + ':' + res.data.data[2][0][1]);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [defaultTraces]);

  useEffect(() => {
    getStatus();
  }, [getStatus]);

  const traces: any = [];
  const rows2 = [];
  function createData2(
    job: string,
    duration: string,
    start_date: string,
    end_date: string
  ) {
    return { job, duration, start_date, end_date };
  }
  Object.keys(data).forEach(function (key) {
    rows2.push(
      createData2(data[key][0], data[key][3], data[key][1], data[key][2])
    );
    const trace = {
      showlegend: false,
      mode: 'lines',
      line: { width: 20 },
      name: data[key][0],
      x: [data[key][1], data[key][2]],
      y: [data[key][0], data[key][0]],
      hovertemplate: '<b>経過時間'+data[key][3]+'秒</b>'
    };
    traces.push(trace);
  });


  return (
    <Stack spacing={2}>
      <Stack spacing={2} direction='row'>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <FormControl fullWidth>
            <DateTimePicker
              label='Start Date'
              ampm={false}
              value={startDate}
              onChange={(newValue) => {
                setStartDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
          <FormControl fullWidth>
            <DateTimePicker
              label='End Date'
              ampm={false}
              value={endDate}
              onChange={(newValue) => {
                setEndDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </FormControl>
        </LocalizationProvider>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>
            実行タスクセット
          </InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedTaskset}
            label='task set'
            onChange={handleChange1}
          >
            {taskset.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>タスク選択</InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedTask}
            label='Task'
            onChange={handleChange2}
          >
            {task.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id='demo-simple-select-label'>
            オペレーター選択
          </InputLabel>
          <Select
            labelId='demo-simple-select-label'
            id='demo-simple-select'
            value={selectedOperator}
            label='Operator'
            onChange={handleChange3}
          >
            {operator.map((item) => (
              <MenuItem value={item[0] + ':' + item[1]} key={item[0]}>
                {item[1]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Button variant='contained' onClick={handleSubmit}>
          検索
        </Button>
      </Stack>

      <Plot data={traces} layout={layout} config={{'displayModeBar': false}} />

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell>オペレーター</TableCell>
              <TableCell>タスクセット</TableCell>
              <TableCell>タスク</TableCell>
              <TableCell>ジョブ名</TableCell>
              <TableCell>ジョブ実行回数</TableCell>
              <TableCell>継続時間(秒)</TableCell>
              <TableCell>開始時刻</TableCell>
              <TableCell>終了時刻</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsTitle.map((item) => {
              let tasksetrowSpanNum = 1 + 2 * rows.length;
              for (let i= 0; i < rows.length; i++){
                tasksetrowSpanNum += rows[i].data.length + 1;
              }
              return (
                <>
                  <TableRow key={item.operatorName}>
                    <TableCell rowSpan={tasksetrowSpanNum}>{item.operatorName}</TableCell>
                  </TableRow>
                  <TableRow key={item.tasksetName}>
                    <TableCell rowSpan={tasksetrowSpanNum}>{item.tasksetName}</TableCell>
                  </TableRow>
                  <TableRow key={item.taskName}>
                    <TableCell rowSpan={tasksetrowSpanNum}>{item.taskName}</TableCell>
                  </TableRow>
                  {rows.map((job) => {
                    const jobrowSpanNum = job.data.length + 1;
                    return (
                      <>
                        <TableRow key={job.jobName}>
                          <TableCell rowSpan={jobrowSpanNum}>{job.jobName}</TableCell>
                          <TableCell rowSpan={jobrowSpanNum}>{job.data.length}回</TableCell>
                        </TableRow>
                        {job.data.map((data) => {
                          return (
                            <TableRow key={data[1]}>
                              <TableCell>{data[3]}秒</TableCell>
                              <TableCell>{data[1].substring(0,data[1].length-3)}</TableCell>
                              <TableCell>{data[2].substring(0,data[2].length-3)}</TableCell>
                            </TableRow>
                          );
                        })} 
                      </>
                    );
                  })}  
                </>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
    </Stack>
  );
};

export default Graph2;
